import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { AppUpdateService } from './app-update.service';

/**
 * Root host. Authenticated chrome lives in route shells:
 * - `/v0/**` → LegacyShellComponent (top nav)
 * - authenticated default → AppShellComponent (left rail)
 * - auth pages render without a shell
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styleUrl: './app.scss',
})
export class AppComponent {
  title = 'scryber-ui';

  constructor(appUpdate: AppUpdateService) {
    appUpdate.start();
    if (Capacitor.isNativePlatform()) {
      void SplashScreen.hide();
      this.configureNativeShell();
    }
  }

  /** Capacitor WKWebView: lock viewport width and block horizontal document pan. */
  private configureNativeShell(): void {
    if (typeof document === 'undefined') {
      return;
    }
    const root = document.documentElement;
    root.classList.add('capacitor-native');
    root.style.overflowX = 'hidden';
    root.style.width = '100%';
    root.style.maxWidth = '100%';
    document.body.style.overflowX = 'hidden';
    document.body.style.width = '100%';
    document.body.style.maxWidth = '100%';
    document.body.style.position = 'relative';
    document.querySelector('meta[name="viewport"]')?.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
    );
  }
}
